// Specialization

$(function () {
  $('.jsSpecializationCollapsing').on('show.bs.collapse hide.bs.collapse', function () {
    $('.SpecializationVisible').toggleClass('show')
  })
})
